import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../Dialog/Dialog";
import { useTranslation } from "react-i18next";
import PrimaryButton from "../PrimaryButton/PrimaryButton";

interface RevealPartnerDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  partnerName: string;
  currentCredits: number;
}

export function RevealPartnerDialog({ 
  isOpen, 
  onClose, 
  onConfirm, 
  currentCredits 
}: RevealPartnerDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-500 to-pink-500">
            {t("partners.find.reveal_title", "Reveal Partner Details")}
          </DialogTitle>
          <DialogDescription className="text-base">
            {t("partners.find.reveal_description", "You're about to reveal all contact information and details for this partner")}
          </DialogDescription>
        </DialogHeader>
        <div className="py-6 space-y-4">
          <div className="flex items-center justify-between p-4 bg-muted/50 rounded-lg">
            <div className="space-y-1">
              <p className="text-sm font-medium">{t("partners.find.reveal_current_credits", "Current Credits")}</p>
              <p className="text-3xl font-bold text-primary">{currentCredits}</p>
            </div>
            <div className="text-muted-foreground">→</div>
            <div className="space-y-1">
              <p className="text-sm font-medium">{t("partners.find.reveal_after_reveal", "After Reveal")}</p>
              <p className="text-3xl font-bold text-primary">{currentCredits - 1}</p>
            </div>
          </div>
          <div className="text-sm text-muted-foreground">
            {t("partners.find.reveal_info_message", "This will reveal all contact information, social media details, and partnership data for this partner.")}
          </div>
        </div>
        <div className="flex justify-center space-x-2">
          <PrimaryButton
            text={t("partners.find.reveal_cta", "Reveal Details").toString()}
            fn={onConfirm}
            eventName="reveal_partner_details"
            actionName="Reveal Partner Details"
            isDisabled={currentCredits < 1}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
} 